/**
 * メニュー固定
 */

/* "passive" が使えるかどうかを検出 */
let passiveSupported = false;
try {
  window.addEventListener(
    'test',
    null,
    Object.defineProperty({}, 'passive', {
      get() {
        passiveSupported = true;
      },
    }),
  );
} catch (err) {}

function checkMediaQuery() {
  const menuElements = document.getElementById('js-menu');

  // MediaQueryListオブジェクトを作成
  const mediaQueryList = window.matchMedia('(max-width: 600px)');
  let scrollFlg = false;

  function getMenuPosition() {
    let positionY = 0;
    const rect = menuElements.getBoundingClientRect();
    positionY = rect.top + window.pageYOffset;
    return positionY;
  }

  function setScrollAddClass(position) {
    const menuClassList = menuElements.classList;
    const pageScroll = window.pageYOffset;

    if (!scrollFlg) {
      window.requestAnimationFrame(() => {
        if (pageScroll > position && !menuClassList.contains('is-active')) {
          menuClassList.add('is-active');
        } else if (
          pageScroll < position &&
          menuClassList.contains('is-active')
        ) {
          menuClassList.remove('is-active');
        }
        scrollFlg = false;
      });

      scrollFlg = true;
    }
  }

  // 関数を定義
  function handle() {
    const position = getMenuPosition();

    window.addEventListener(
      'scroll',
      () => {
        const oNavTrigger = document.getElementById('js-oNav-trigger');

        if (!oNavTrigger.classList.contains('is-open')) {
          setScrollAddClass(position);
        }
      },
      passiveSupported ? { passive: true } : false,
    );
  }

  // スクリプトが読み込まれたときに、関数を実行
  handle(mediaQueryList);

  // イベントリスナーを設定して、ウィンドウの縦横比が変わる度に、関数を実行する
  mediaQueryList.addEventListener('change', handle, false);
}

function init() {
  document.addEventListener('DOMContentLoaded', checkMediaQuery);
}

module.exports = init;
